import { render, staticRenderFns } from "./DigitalPrintOrders.vue?vue&type=template&id=153a1702"
import script from "./DigitalPrintOrders.vue?vue&type=script&lang=js"
export * from "./DigitalPrintOrders.vue?vue&type=script&lang=js"
import style0 from "./DigitalPrintOrders.vue?vue&type=style&index=0&id=153a1702&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports